import { useLocation, useNavigate } from "react-router-dom";
import { X, Edit, Trash2 } from "lucide-react";
import { getPriorityColor, getStatusColor } from "../../utils/colors";

const formatText = (text = "") =>
  text
    .toLowerCase()
    .split("_")
    .map(w => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");

const formatDate = (date) => {
  if (!date) return "N/A";
  return new Date(date).toLocaleDateString();
};

export default function WorkflowView() {
  const navigate = useNavigate();
  const { state: viewTask } = useLocation();   
  console.log("view===>Task",viewTask)
  // 👈 RECEIVED DATA

  if (!viewTask) {
    navigate(-1);
    return null;
  }

  return (
     <div
            // onClick={() => setViewTask(null)}
            className="fixed inset-0 bg-black bg-opacity-50 z-40 flex items-center justify-center"
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="bg-white rounded-lg shadow-2xl max-w-[100vw] w-full max-h-[100vh] overflow-x-auto"
            >
              {/* Header */}
              <div className="flex justify-between items-center px-2 py-2 border-b">
                <div className="text-lg font-semibold text-gray-900">
                  Workflow Details
                </div>
                <button
                //   onClick={() => setViewTask(null)}
                  className="p-1 rounded-md bg-red-50 text-red-700 hover:bg-red-100"
                >
                  <X size={20} />
                </button>
              </div>
    
              {/* Body */}
              <div className="p-2 text-sm space-y-1">
                {/* Title */}
                <div>
                  <div className="text-lg font-semibold text-gray-900">
                    {viewTask?.name}
                  </div>
                  <div className="text-xs text-gray-400">Workflow Overview</div>
                </div>
    
                {/* Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-1">
                  <InfoCard
                    label="Assignee"
                    value={viewTask?.createdBy?.fullName || "N/A"}
                  />
                  <InfoCard
                    label="Workflow"
                    value={formatText(viewTask?.template)}
                  />
                  <InfoCard
                    label="Start Date"
                    value={viewTask?.startDate || "N/A"}
                  />
                  <InfoCard
                    label="Due Date"
                    value={viewTask?.dueDate || "N/A"}
                  />
                  <StatusBadge status={viewTask?.status} />
                </div>
    
                {/* Description */}
                {viewTask?.description && (
                  <div className="border-t pt-1">
                    <p className="text-xs text-gray-400 mb-1">Description</p>
                    <div className="bg-gray-50 rounded-lg px-3 py-2 text-gray-700">
                      {viewTask.description}
                    </div>
                  </div>
                )}
    
                {/* <WorkflowDocumentsViewer workflowId={viewTask.id} /> */}
    
              </div>
              <div className="p-2 grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
                {viewTask?.tasks?.length > 0 ? (
                    viewTask?.tasks?.map((task) => (
                        <div key={task.id} className=" border border-gray-200 rounded-lg p-3 shadow-sm">
                            <div className="flex justify-between items-start">
                                <div className="flex-grow">
                                    <div className="flex items-center gap-2 mb-0">
                                        <div className="font-semibold text-base text-gray-800">{task.title}</div>
                                        <span className={`px-2 py-1 rounded-full text-xs font-medium ${getPriorityColor(task.priority)}`}>
                                            {task.priority}
                                        </span>
                                        <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(task.status)}`}>
                                            {task.status.replace('_', ' ')}
                                        </span>
                                    </div>
                                    {task.description && (
                                        <p className="text-gray-600 text-sm mb-0">{task.description}</p>
                                    )}
                                    <div className="flex flex-wrap gap-4 text-xs text-gray-500">
                                        <span className="flex items-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                            </svg>
                                            Start: {formatDate(task.startDate)}
                                        </span>
                                        <span className="flex items-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                            </svg>
                                            Due: {formatDate(task.dueDate)}
                                        </span>
                                    </div>
                                </div>
                                {/* <div className="space-x-1">
                                  <button
                                      // onClick={() => {setEditTask(task); setTaskId(task?.id)}}
                                      onClick={() => {setTaskId(task?.id); 
                                          setEditTask({
                                            title: task?.title || "",
                                            description: task?.description || "",
                                            startDate: task?.startDate || "",
                                            dueDate: task?.dueDate || "",
                                            priority: task?.priority || "",
                                            status: task?.status || "TODO",
                                            account: task?.account?.id || "",
                                            workflowId: task?.workflowName ? workflowDropdown?.find( (item) => item.label === task.workflowName )?.value : "",
                                            assignedTo: task?.assignedTo?.id || "",
                                          });
                                        setAttachments(task?.attachments);
                                        setComments(task?.comments.length !==0 ? task?.comments : [{ content: "" }]);
                                      }}
                                      className="text-blue-500 hover:text-blue-700"
                                      aria-label="Delete task"
                                      title="Delete task"
                                  >
                                      <Edit size={16}/>
                                  </button>
                                  <button
                                      onClick={() => deleteTasksWorkflow(task.id)}
                                      className="text-red-500 hover:text-red-700"
                                      aria-label="Delete task"
                                      title="Delete task"
                                  >
                                      <Trash2 size={16}/>
                                  </button>
                                </div> */}
                            </div>
                        </div>
                    ))
                ) : (
                    <p className="text-gray-500 text-center py-4">No tasks available.</p>
                )}
              </div>
            </div>
          </div>
  );
}

/* SAME Components */

const InfoCard = ({ label, value }) => (
  <div className="bg-gray-50 rounded p-2">
    <div className="text-xs text-gray-400">{label}</div>
    <div className="font-medium">{value || "N/A"}</div>
  </div>
);

const StatusBadge = ({ status }) => (
  <div className="bg-gray-50 rounded p-2">
    <div className="text-xs text-gray-400">Status</div>
    <span className="px-3 py-1 rounded-full text-xs bg-blue-100">
      {formatText(status)}
    </span>
  </div>
);
